import { render, staticRenderFns } from "./receipt-form.vue?vue&type=template&id=20ef5654"
import script from "./receipt-form.vue?vue&type=script&lang=js"
export * from "./receipt-form.vue?vue&type=script&lang=js"
import style0 from "./receipt-form.vue?vue&type=style&index=0&id=20ef5654&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports